export { default } from './FavoritesCustomForecast';
